module.exports = __webpack_public_path__ + "img/IV-prez.3f58a322.png";